import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import TitleCard from '../Components/TitleCard.js';
import { formatDate } from '../utils/utils';
import Button from '../Components/Button.js';
import { ChevronRight } from 'lucide-react';

export class ArticleCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 'home',
        };
    }

    handleSelect = (selectedKey) => {
        this.setState({ selectedTab: selectedKey });
    };

    getCategoryIconSrc = (categoria) => {
        switch (categoria) {
            case 'ANÁLISES':
                return '/images/icons/chart.svg';
            case 'ECONOMIA':
                return '/images/icons/diagram_up.svg';
            case 'ESTUDOS TÉCNICOS':
                return '/images/icons/clipboard_text.svg';
            case 'TENDÊNCIAS':
                return '/images/icons/chat_square_check.svg';
            case 'TRANSPARÊNCIA':
                return '/images/icons/round_graph.svg';
            default:
                return '/images/icons/Buildings.svg';
        }
    };


    render() {
        const { image, alt, title, text, id, author, date, category } = this.props;
        const isMobile = window.innerWidth <= 767;

        // const limit = isMobile ? 300 : 900;

        // let textFinal = text.substring(0, limit);

        // if (text.length > limit) {
        //     textFinal += "...";
        // }

        return (
            <div className='article-block' style={{ marginBottom: '29px', textDecoration: 'none', color: 'inherit' }}>
                {image && (
                    <img
                        src={image}
                        width="317"
                        height="200"
                        className="d-inline-block align-top article-image"
                        alt={alt}
                        style={{ maxHeight: isMobile ? '180px' : 'auto', maxWidth: isMobile ? 'min(100%, 767px)' : 'min(100%, 1140px)', minWidth: '317px', borderRadius: '30px' }}
                    />
                )}
                <div style={{ marginTop: '30px', marginBottom: '20px' }}>
                    <TitleCard
                        iconLeft={<img
                            src={this.getCategoryIconSrc(category)}
                            width="18"
                            alt={category ? category : 'OUTROS'}
                        />}
                        label={category ? category : 'OUTROS'}
                    />
                </div>

                <div className='card-person'>
                    <span className='article-title'>{title}</span>
                    <span className='article-content'>{text}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px', marginTop: '20px' }}>
                    <div>
                        <img
                            src="/images/blog/user.svg"
                            width="20"
                            alt="Autor"
                        />
                        <span style={{ fontSize: '14px', color: '#818181', marginLeft: '5px' }}>{author}</span>
                    </div>

                    <div>
                        <img
                            src="/images/blog/calendar.svg"
                            width="20"
                            alt="Data"
                        />
                        <span style={{ fontSize: '14px', color: '#818181', marginLeft: '5px' }}>
                            {formatDate(date)}
                        </span>
                    </div>
                </div>
                <Link to={`/article-details/${id}`} style={{ textDecoration: 'none' }}>
                    <Button
                        label="Ler artigo"
                        $variant="primary"
                        size="small"
                        iconRight={<ChevronRight />}
                    />
                </Link>
            </div>
        );
    }
}

export default ArticleCard;
